import React, {useMemo, useState} from "react";
import useIsMounted from "../../../../hooks/use-is-mounted";
import {Col} from "reactstrap";
import Chips, {ChipsContentType, ChipsIconPosition, ChipsTypes} from "../../../base/chips/chips";
import ProductInformationPopover from "../../draggable-popover/product-information-popover";
import PartAutocomplete from "../../../text-fields/autocomplete/part-autocomplete";


const ProductRelationCard = ({relation, add, remove, filters, owningProductId}) => {
    const [adding, setAdding] = useState(false);
    const [removing, setRemoving] = useState([]);
    const isMounted = useIsMounted();

    const existingProductIds = useMemo(() => relation.relatedParts?.map(e => e.id) ?? [], [relation])
    const products = useMemo(() => {
        const keywords = (filters ?? '').toLowerCase();
        return relation.relatedParts?.filter(e => e.partNo?.toLowerCase()?.includes(keywords))
    }, [filters, relation])

    /**
     * Adds the given product to the list of relations of the current relation type.
     * @param product
     * @return {Promise<void>}
     */
    const addNewProduct = async (product) => {
        setAdding(true);
        await add(product, relation.type);
        if (!isMounted()) return;
        setAdding(false);
    }

    /**
     * Removes the given product from the list of relations of the current relation type.
     * @param product
     * @return {Promise<void>}
     */
    const removeProduct = async (product) => {
        setRemoving(prevState => [...prevState, product.id]);
        await remove(product, relation.type);
        if (!isMounted()) return;
        setRemoving(prevState => prevState.filter(e => e !== product.id));
    }

    return (
        <>
            <div className={'product-relation-card part-info-paper '}>
                <Col xs={12} className={'mb-3 px-0'}>
                    <p className={'text-md black font-weight-semi-bold'}>
                        {relation.type?.title ?? ''}
                    </p>
                </Col>
                {
                    products?.map(product => (
                        <Chips
                            key={product.id}
                            className={'mr-2 mb-2 part-number-fluid'}
                            iconPosition={ChipsIconPosition.start}
                            contentType={ChipsContentType.element}
                            content={
                                <ProductInformationPopover partNo={product?.partNo ?? product?.partNumber}>
                                    {product?.partNo ?? product?.partNumber ?? ''}
                                </ProductInformationPopover>
                            }
                            onIconClick={() => removeProduct(product)}
                            type={removing?.includes(product.id) ? ChipsTypes.loading : ChipsTypes.remove}
                        />
                    ))
                }
                {
                    adding &&
                    <Col xs={6} md={4} lg={3} className={'loading small mr-2 mb-2 px-0'}>
                        <div/>
                    </Col>
                }
                <Col xs={12} md={6} lg={5} xl={4} className={'mr-2 mb-2 px-0'}>
                    <PartAutocomplete
                        clearOnBlur
                        value={null}
                        label={"New Product"}
                        onChange={(_, value) => value && addNewProduct(value)}
                        getOptionLabel={v => v?.partNo ?? v?.partNumber ?? ''}
                        filterOptions={(options) => options.filter(e => !existingProductIds.includes(e.id) && owningProductId !== e.id)}
                    />
                </Col>
            </div>
        </>
    );
}

export default ProductRelationCard;
